import { SerializePayload } from 'app/area/search-filters/types';
import { filterId } from './constants';
import { DashboardSearchModel } from './types-store';

const serializeQuery = (query: string) =>
  query && query.trim().length
    ? {
      [filterId.query]: {
        text: query.trim()
      }
    }
    : {};

export const serialize = (payload: SerializePayload): DashboardSearchModel => serializeQuery(payload.query);
